module.exports = __webpack_public_path__ + "static/img/content12.f8cf53d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/content12.png
// module id = AJzW
// module chunks = 1 3